import { Interpolation } from "@emotion/core";
import { Border } from "../../design-tokens/borders";
import { Colors } from "../../design-tokens/colors";
import { DarkTheme } from "../../design-tokens/media-queries";
import { grid } from "../../design-tokens/grid";
import { Fonts } from "../../design-tokens/fonts";
import { BoxShadow } from "../../design-tokens/box-shadow";

const root: Interpolation = {
  position: "relative",
  display: "flex",
  flexDirection: "column",
  color: Colors.Black,
  backgroundColor: Colors.White,
  boxShadow: BoxShadow.Default,
  borderRadius: Border.Radius,
  transition: "all 0.2s ease",
  overflow: "hidden",
  marginBottom: grid(1),

  [DarkTheme]: {
    color: Colors.White,
    backgroundColor: Colors.DarkModeBackground,
  },

  ":hover": {
    textDecoration: "none",
    transform: "translateY(-4px)",
  },
};

const image: Interpolation = {
  flexShrink: 0,
  display: "flex",
  alignItems: "center",
  height: grid(20),
  overflow: "hidden",
  backgroundColor: Colors.LightGrey,

  [DarkTheme]: {
    backgroundColor: Colors.DarkModeGrey,
  },

  "> img": {
    width: "100%",
    height: grid(20),
    minWidth: "100%",
    minHeight: "100%",
    objectFit: "cover",
  },
};

const content: Interpolation = {
  flexGrow: 0,
  flex: 1,
  display: "flex",
  flexDirection: "column",
  padding: grid(2),
  paddingBottom: grid(3),
};

const title: Interpolation = {
  fontSize: "24px",
  lineHeight: "32px",
  fontWeight: Fonts.Weight.Bold,
  marginBottom: grid(2),
};

const description: Interpolation = {
  marginBottom: grid(2),
};

const ctaText: Interpolation = {
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  WebkitAppearance: "none",
  minWidth: grid(19),
  height: grid(4),
  fontWeight: Fonts.Weight.SemiBold,
  color: Colors.Blue,
  backgroundColor: Colors.LightGrey,
  borderRadius: grid(4),
  marginTop: "auto",
  marginBottom: 0,

  ":hover": {
    textDecoration: "none",
  },

  [DarkTheme]: {
    color: Colors.DarkModeTextBlue,
    backgroundColor: Colors.DarkModeBlack,
  },
};

const styles = {
  root,
  image,
  content,
  title,
  ctaText,
  description,
};

export default styles;
